import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-4 w-24 bg-white/10 animate-pulse rounded" />
        <div className="h-4 w-20 bg-white/10 animate-pulse rounded" />
        <div className="h-4 w-28 bg-white/10 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col items-start gap-2">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-white hover:text-primary transition-colors text-sm">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const legalLinks = [{
    id: 1,
    label: "Impressum",
    href: "https://muensterland-industrieservice.com/impressum-und-datenschutz/impressum/"
  }, {
    id: 2,
    label: "Datenschutz",
    href: "https://muensterland-industrieservice.com/impressum-und-datenschutz/dsgvo/"
  }, {
    id: 3,
    label: "Allgemeine Geschäftsbedingungen (AGB)",
    href: "https://muensterland-industrieservice.com/impressum-und-datenschutz/allgemeine_geschaeftsbedingungen/"
  }, {
    id: 4,
    label: "Cookie-Richtlinie",
    href: "https://muensterland-industrieservice.com/impressum-und-datenschutz/cookie_richtlinie/"
  }];
  return <footer className="bg-[#2B2D2F] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {}
          <div data-index={0}>
            <h3 className="text-xl font-semibold mb-4">Münsterland Industrieservice UG (haftungsbeschränkt)</h3>
            <p className="text-sm text-white/90 mb-3 leading-relaxed">
              Ihr verlässlicher Partner im Münsterland für Flächenreinigung ohne chemische Zusätze, Hausmeistertätigkeiten im nicht handwerkspflichtigen Bereich, Gartenpflege, Bürotätigkeiten sowie Hilfeleistungen im Bereich Büroorganisation.
            </p>
            <div className="flex flex-col gap-3">
              <div>
                <p className="text-sm text-white/90">Adresse:</p>
                <p className="text-white">Grüner Weg 60</p>
                <p className="text-white">48329 Havixbeck</p>
              </div>
              <div>
                <p className="text-sm text-white/90">Telefon:</p>
                <Link to="tel:+491702949140" className="text-white hover:text-primary transition-colors">
                  +49 170 294 9140
                </Link>
              </div>
              <div>
                <p className="text-sm text-white/90">E-Mail:</p>
                <Link to="mailto:muensterland.is@gmail.com" className="text-white hover:text-primary transition-colors">
                  muensterland.is@gmail.com
                </Link>
              </div>
              <div>
                <p className="text-sm text-white/90">Öffnungszeiten:</p>
                <p className="text-white">Montag - Freitag: 08:00 - 18:00 Uhr</p>
              </div>
            </div>
          </div>

          {}
          <div data-index={1}>
            <h3 className="text-xl font-semibold mb-4">Unternehmensdaten</h3>
            <div className="flex flex-col gap-2 text-sm">
              <div>
                <p className="text-white/90">USt-IdNr.:</p>
                <p className="text-white">DE454728639</p>
              </div>
              <div>
                <p className="text-white/90">Steuernummer:</p>
                <p className="text-white">312/5818/1773</p>
              </div>
              <div>
                <p className="text-white/90">Registergericht:</p>
                <p className="text-white">Amtsgericht Coesfeld</p>
                <p className="text-white font-medium">HRB 22918</p>
              </div>
              <div>
                <p className="text-white/90">Geschäftsführer:</p>
                <p className="text-white">Yevhen Bulda</p>
              </div>
            </div>
          </div>

          {}
          <div data-index={2}>
            <Link to="https://muensterland-industrieservice.com/impressum-und-datenschutz/" className="text-xl font-semibold mb-4 inline-block hover:text-primary transition-colors underline">
              Rechtliches
            </Link>
            <div className="flex flex-col gap-3 mb-6">
              {legalLinks.map((link, i) => <Link key={link.id} data-index={i} to={link.href} className="text-white hover:text-primary transition-colors text-sm underline">
                  {link.label}
                </Link>)}
            </div>
            <div className="mt-6 pt-6 border-t border-white/10">
              <h4 className="text-sm font-semibold mb-2 text-white/90">Bankverbindung</h4>
              <div className="flex flex-col gap-1 text-sm">
                <p className="text-white">Sparkasse Westmünsterland</p>
                <p className="text-white/90">IBAN:</p>
                <p className="text-white">DE20 4015 4530 0036 2888 50</p>
                <p className="text-white/90">BIC:</p>
                <p className="text-white">WELADE3WXXX</p>
              </div>
            </div>
          </div>

          {}
          <div data-index={3}>
            <h3 className="text-xl font-semibold mb-4">Navigation</h3>
            <MenuProvider menu_id="24">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>

        {}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-sm text-white/70">
            © {new Date().getFullYear()} Münsterland Industrieservice UG (haftungsbeschränkt). Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>;
}